import { useState } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import Sidebar from './Sidebar'
import Header from './Header'
import Transactions from './Transactions'
import Channels from './Channels'
import Cuentas from './Cuentas'
import Configuration from './Configuration'
import Webhooks from './Webhooks'
import Usuarios from './Usuarios'
import Profile from './Profile'

const routes = [
    { path: '/', component: Transactions },
    { path: '/transacciones', component: Transactions },
    { path: '/canales', component: Channels },
    { path: '/cuentas', component: Cuentas },
    { path: '/webhooks', component: Webhooks },
    { path: '/configuracion', component: Configuration },
    { path: '/usuarios', component: Usuarios },
    { path: '/perfil', component: Profile },
]

export default function Home() {
    const [titulo, setTitulo] = useState('Transacciones')
    const [sidebarOpen, setSidebarOpen] = useState(false)
    const [collapsed, setCollapsed] = useState(false)

    return (
        <div className="min-h-full bg-slate-50">
            <Sidebar
                open={sidebarOpen}
                onClose={() => setSidebarOpen(false)}
                collapsed={collapsed}
                onToggle={() => setCollapsed((value) => !value)}
            />
            <div className={`transition-[padding] duration-200 ${collapsed ? 'lg:pl-20' : 'lg:pl-56'}`}>
                <Header titulo={titulo} onMenu={() => setSidebarOpen(true)} />
                <main>
                    <Routes>
                        {routes.map((route) => (
                            <Route
                                key={route.path}
                                path={route.path}
                                element={<route.component handleTitulo={setTitulo} />}
                            />
                        ))}
                        <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                </main>
            </div>
        </div>
    )
}
